<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">
            Ocorrências | {{id}}
          </p>
          <div class="heading-elements">
            <i class="fas fa-long-arrow-alt-left position-left" @click="voltar()" style="cursor: pointer"></i>
          </div>
        </div>

        <div class="box-body">
					<div v-show="errorMessage != ''" class="alert alert-danger">{{ errorMessage }}</div>

          <div class="row">
            <div class="form-group col-12 col-md-12">
              <label for="descricao">Descrição</label>
              <br />{{ registro.descricao }}
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="cd_motivo">Motivo <sup class="text-danger">* </sup></label>
              <select id="cd_motivo" v-model="registro.cd_motivo" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.cd_motivo }">
                <option v-for="item in motivos" v-bind:value="item.cd_motivo">{{ item.descricao }}</option>
              </select>
              <span v-show="errors.cd_motivo != null" class="help-inline">{{ errors.cd_motivo }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="idc_status">Status <sup class="text-danger">* </sup></label>
              <select id="idc_status" v-model="registro.idc_status" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.idc_status }">
                <option value="1">Aguardando Atendimento</option>
                <option value="2">Em Atendimento</option>
                <option value="3">Pendente</option>
                <option value="4">Concluído</option>
                <option value="8">Cancelado</option>
              </select>
              <span v-show="errors.idc_status != null" class="help-inline">{{ errors.idc_status }}</span>
            </div>
            <div class="form-group col-12 col-md-12">
              <label for="observacao">Observação</label>
              <textarea id="observacao" rows="4" v-model="registro.observacao" class="form-control" v-bind:class="{ 'box-input-required': errors.observacao }"></textarea>
              <span v-show="errors.observacao != null" class="help-inline">{{ errors.observacao }}</span>
            </div>
          </div>
        </div>

        <div class="box-footer text-center">
          <div class="btn-group">
            <button type="button" id="cancelButton" class="btn btn-warning" @click="voltar()">Cancelar</button>
            <button type="button" id="gravarButton" class="btn btn-success" @click="gravar()">Gravar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OcorrenciaActions from '../../actions/OcorrenciaActions'
import OcorrenciaMotivoActions from '../../actions/OcorrenciaMotivoActions'

export default {
  name: 'editar',
  props: ['id'],
  data () {
    return {
      errorMessage: '',
      errors: {},
      hasError: false,
      registro: {
        descricao: '',
        observacao: '',
        idc_status: ''
      },
      motivos: []
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Editar'

    OcorrenciaActions.obterOcorrencia(this.id)
      .then(res => {
        if (res && res.descricao) {
          this.registro = res
        } else {
          this.errorMessage = 'Registro não encontrado.'
        }
      })
      .catch((error) => {
        console.log(error.message)
        this.errorMessage = 'Registro não encontrado.'
      })

    OcorrenciaMotivoActions.listarMotivosAtivos()
      .then(res => {
        this.motivos = res
      })
  },
  methods: {
    voltar () {
      this.$router.push('/ocorrencias')
    },
    validation () {
      this.errors = {}
      this.hasError = false

      if (!this.registro.idc_status) {
        this.errors.idc_status = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.cd_motivo) {
        this.errors.cd_motivo = 'Este campo deve ser preenchido.'
        this.hasError = true
      }
    },
    gravar () {
      this.validation()

      if (!this.hasError) {
        this.$parent.$parent.$data.showModalLoader = true

        OcorrenciaActions.alterarOcorrencia({
          id: this.id,
          descricao: this.registro.descricao,
          observacao: this.registro.observacao,
          idc_status: this.registro.idc_status
        })
        .then(response => {
          this.$parent.$parent.$data.showModalLoader = false
          this.$router.push('/ocorrencias')
        })
        .catch((error) => {
          console.log(error.message)
          this.errorMessage = 'Ocorreu um erro ao gravar o registro.'
          this.$parent.$parent.$data.showModalLoader = false
        })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/ocorrencias/Editar.vue